/* --------------------------------------------------------------------------------------
   printTests.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import angular from 'angular'
import uiRouter from "@uirouter/angularjs";
import printTestsService from './services/printTests.service'
import { studentsComponent, studentsCtrl } from './components/students.component'
import '../common/common'

const printTestsComponent = {
  template: require('./printTests.html'),
  controller: 'printTestsCtrl',
  controllerAs: 'vm'
}

class printTestsCtrl {
    /*@ngInject*/
  constructor ($state, printTestsService) {
    this.$state = $state
    this.printTestsService = printTestsService
  }
  $onInit () {
    this.step = 0;
  }
  back() {
    this.step--
    if (this.step < 0)
      this.$state.go('main')
  }
  next () {
    this.step++
    if (this.step > 2)
      this.print()
  }
}

export const appPrintTestsModule = angular.module('app.printTests', ['ui.router','app.common'])
  .component('students', studentsComponent)
  .controller('studentsCtrl', studentsCtrl)
  .component('printTests', printTestsComponent)
  .controller('printTestsCtrl', printTestsCtrl)
  .service('printTestsService', printTestsService)



// WEBPACK FOOTER //
// ./src/app/printTests/printTests.js